/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/NewsEntryAutomatedSource', 'model/AutomatedSourceGeneratedNews'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/NewsEntryAutomatedSource'), require('../model/AutomatedSourceGeneratedNews'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.NewsEntryAutomatedSourceApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.NewsEntryAutomatedSource, root.ForStractionServiceApi.AutomatedSourceGeneratedNews);
  }
}(this, function(ApiClient, NewsEntryAutomatedSource, AutomatedSourceGeneratedNews) {
  'use strict';

  /**
   * NewsEntryAutomatedSource service.
   * @module api/NewsEntryAutomatedSourceApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new NewsEntryAutomatedSourceApi. 
   * @alias module:api/NewsEntryAutomatedSourceApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the newsEntryAutomatedSourceLoadAllGet operation.
     * @callback module:api/NewsEntryAutomatedSourceApi~newsEntryAutomatedSourceLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/NewsEntryAutomatedSource>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/NewsEntryAutomatedSourceApi~newsEntryAutomatedSourceLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/NewsEntryAutomatedSource>}
     */
    this.newsEntryAutomatedSourceLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryAutomatedSourceLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [NewsEntryAutomatedSource];

      return this.apiClient.callApi(
        '/NewsEntryAutomatedSource/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntryAutomatedSourcePostGeneratedNewsPut operation.
     * @callback module:api/NewsEntryAutomatedSourceApi~newsEntryAutomatedSourcePostGeneratedNewsPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * postGeneratedNews
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/AutomatedSourceGeneratedNews>} body 
     * @param {module:api/NewsEntryAutomatedSourceApi~newsEntryAutomatedSourcePostGeneratedNewsPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.newsEntryAutomatedSourcePostGeneratedNewsPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryAutomatedSourcePostGeneratedNewsPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntryAutomatedSourcePostGeneratedNewsPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/NewsEntryAutomatedSource/postGeneratedNews', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
